import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ClothingType } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class ClothingTypeApiService extends AbstractBasicDataApiService<ClothingType> {

  constructor(
    http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.employees.clothingtype);
  }
}
